import React from "react";
import { altColor } from "../../utils/constants";

export default function FavoriteChildBrandIcon({ color = altColor }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36.22 35.71">
      <g id="Ebene_2" data-name="Ebene 2">
        <g id="Ebene_1-2" data-name="Ebene 1">
          <g id="Childhood_Icon" data-name="Childhood Icon">
            <path
              id="Pfad_1949"
              data-name="Pfad 1949"
              fill="none"
              stroke={color}
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="2px"
              d="M25.36,24.9a2.82,2.82,0,0,1-2.57,2.82A9.8,9.8,0,0,1,4,27.73H3.88a2.83,2.83,0,1,1-.1-5.66H4a9.8,9.8,0,0,1,18.77,0A2.82,2.82,0,0,1,25.36,24.9ZM13,15.1c1.2-.84,1.36-1.4,1.25-1.74-.23-.72-1.6-.8-2-1.63A1.69,1.69,0,0,1,12.73,10m-.57,8.17a2.89,2.89,0,0,0,1.28,1.33c1.76.83,4.44-.57,4.46-1.93,0-.87-1.06-1.73-2.39-2.25m-4.62,9.28a2.07,2.07,0,0,0-4.14.09m4.39,4.74a2.82,2.82,0,0,0,2,1,2.44,2.44,0,0,0,2.09-1m4.34-4.88a2.07,2.07,0,0,0-4.14.09"
            />
            <path
              id="Herz_3"
              data-name="Herz 3"
              fill="#eb3d67"
              d="M23.64,1.16A2.48,2.48,0,0,0,21.54,0,2.56,2.56,0,0,0,19,2.56v.08c0,1.6,1.3,2.66,3.28,4.25l1.08.88a.46.46,0,0,0,.6,0L25,6.89C27,5.3,28.3,4.24,28.3,2.64A2.55,2.55,0,0,0,25.82,0h-.08A2.47,2.47,0,0,0,23.64,1.16Zm3.73,1.48c0,1.16-1.17,2.1-2.94,3.53l-.79.65-.8-.65c-1.76-1.43-2.93-2.37-2.93-3.53A1.64,1.64,0,0,1,21.47.93h.07c1.22,0,1.64,1.34,1.65,1.4a.47.47,0,0,0,.58.32.45.45,0,0,0,.32-.32s.42-1.4,1.65-1.4a1.63,1.63,0,0,1,1.63,1.64Z"
            />
            <path
              id="Herz_2"
              data-name="Herz 2"
              fill="#eb3d67"
              d="M32.26,12.41a.55.55,0,0,0,.37-.14l.88-.75c1.57-1.34,2.71-2.31,2.71-3.75A2.32,2.32,0,0,0,34,5.35h0a2.07,2.07,0,0,0-1.7.85,2.08,2.08,0,0,0-1.7-.85A2.31,2.31,0,0,0,28.3,7.73v0c0,1.44,1.14,2.41,2.71,3.75l.88.75A.55.55,0,0,0,32.26,12.41ZM29.43,7.77a1.2,1.2,0,0,1,1.1-1.29h0c.84,0,1.14,1,1.15,1.07a.57.57,0,0,0,.7.39.55.55,0,0,0,.39-.39S33.12,6.48,34,6.48a1.2,1.2,0,0,1,1.13,1.26v0c0,.92-.87,1.66-2.32,2.89l-.51.44-.52-.44c-1.44-1.23-2.31-2-2.31-2.89Z"
            />
            <path
              id="Herz_2-2"
              data-name="Herz 2"
              fill="#eb3d67"
              d="M25,16.87a.39.39,0,0,0,.26-.09l.62-.54c1.11-.94,1.91-1.62,1.91-2.64a1.64,1.64,0,0,0-1.57-1.71h0a1.48,1.48,0,0,0-1.2.6,1.49,1.49,0,0,0-1.2-.6,1.63,1.63,0,0,0-1.59,1.68v0c0,1,.8,1.7,1.91,2.64l.62.54A.39.39,0,0,0,25,16.87ZM23,13.6a.84.84,0,0,1,.77-.91h0c.59,0,.81.72.82.75a.39.39,0,0,0,.76,0s.23-.75.82-.75a.83.83,0,0,1,.79.89v0c0,.65-.61,1.17-1.63,2L25,16l-.36-.31c-1-.87-1.63-1.39-1.63-2Z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
